import React from 'react';
import {
  FacilityCardWrapper,
  FacilityCardHeader,
  FacilityInfo,
  FacilityName
} from '../Facility/styledComponents';
import HeartIcon from '../../../Assets/Icons/HeartIcon';
import { useHistory } from 'react-router-dom';
import { Popover } from 'antd';

function DictionaryFacilityCard({ facility }) {
  const history = useHistory();
  const gotToDetailedView = id => {
    // Pass facility data via location state for God users
    history.push(`/dashboard/facility-management/${id}`, {
      facilityData: facility.originalData
    });
  };

  return (
    <FacilityCardWrapper disabled={facility.disabled} onClick={() => gotToDetailedView(facility.facilityId)}>
      <FacilityCardHeader>
        <div>
          <HeartIcon />
        </div>{' '}
        <Popover placement='bottom' content={facility.facilityName}>
          <FacilityName>{facility.facilityName}</FacilityName>
        </Popover>
      </FacilityCardHeader>
      {facility.fields.map(field => (
        <FacilityInfo key={field.fieldName}>
          <span>{field.fieldName}</span>
          <span title={field.fieldValue}>{field.fieldValue}</span>
        </FacilityInfo>
      ))}
    </FacilityCardWrapper>
  );
}

export default DictionaryFacilityCard;
